import React from "react";
import Image from "components/image";

const ImageGridWithHeader = ({ data }) => {
    const images = data?.images;
    return (
        <div className="container mx-auto">
            <div className="bg-[#ffcb05] flex items-center justify-center p-3"><h3 className="text-4xl text-center font-semibold text-blue-700 uppercase">{ data?.header }</h3></div>
            <div className="flex flex-wrap">
                {images?.map((item) => (
                    <div className="basis-1/3">
                        <Image image={item?.image.asset} alt={item?.image.alt} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ImageGridWithHeader;
